import React, { useEffect, useRef, useState } from 'react';
import {
	useGetStudioPlayListsQuery,
	useDeleteStudioPlayListMutation,
	usePatchStudioPlayListMutation
} from '../../../service';
import toast from 'react-hot-toast';
import MobileViewSearch from '../../MobileViewSearch';
import { AllPlayList } from '../../common/AllPlayList';
import PlaylistEditModal from './PlaylistEditModal';
import { useAtomValue } from 'jotai';
import { userInfoAtom } from '../../../data/atoms/utilsAtoms';
import DeleteModalPlayList from '../personal-playlist/DeleteModalPlayList';
import DeleteModal from '../personal-playlist/DeleteModal';
import DisplayPlaylistVideos from './DisplayPlaylistVideos';
import { useDispatch, useSelector } from 'react-redux';
import { getStudioPlayList } from '../../../redux/studioPlayListSlice';
import checkApiStatus from '../../SubscripStatus';
import Toast from '../../../utils/toastManager';
import playlistApi from '../../../api/playlistApi';
import { current } from '@reduxjs/toolkit';
import { useSavedVideos } from '../../../v2/pages/PersonalPlayList/hooks/useSavedVideos';
import UndoModal from '../../../v2/components/UndoModal';
import { sortVideosByPosition } from '../../../utils/sortVideos';

const StudioPlayList = () => {
	const dispatch = useDispatch();
	const userInfo = useAtomValue(userInfoAtom);
	const {
		data,
		isError,
		refetch: reqGetStudioPlayLists,
		isSuccess: resGetStudioPlayLists
	} = useGetStudioPlayListsQuery(undefined, {
		refetchOnMountOrArgChange: true,
		skip: !userInfo
	});
	const [playlists, setPlaylists] = useState([]);
	const [currentPlaylistId, setCurrentPlaylistId] = useState('');
	const [reqDeleteStudioPlayList, resDeleteStudioPlayList] = useDeleteStudioPlayListMutation();
	const [reqPatchStudioPlayList, resPatchStudioPlayList] = usePatchStudioPlayListMutation();
	const videoIdsToRemove = [];
	const [showModal, setModalShow] = useState(false);
	const [nshowModal, setnModalShow] = useState(false);
	const [editPlaylistID, setEditPlaylistID] = useState('');
	const [subscribtionStatus, setSubscribtionStatus] = useState(false);


	useEffect(() => {
		const getSubscription = async () => {

			const subscribtionStatus = await checkApiStatus(userInfo.token);
			setSubscribtionStatus(subscribtionStatus);
		};
		getSubscription();
	}, []);


	const shuffledPlaylists = useSelector(state => state.studioPlayListState.studioPlayList);

	const handleClose = () => {
		setModalShow(false);
		reqGetStudioPlayLists();
	};


	useEffect(() => {
		const handlePlaylistData = async () => {
			try {
				const responseFromStudio = data?.data?.data
				if (resGetStudioPlayLists && responseFromStudio) {
					dispatch(getStudioPlayList(responseFromStudio));

					setPlaylists(responseFromStudio);
					if (responseFromStudio.length > 0) {
						setCurrentPlaylistId(responseFromStudio[0]._id);
					}
				}
			} catch {
				toast.error('Something went wrong', {
					position: 'top-center',
					duration: 3000
				});
				setPlaylists([]);
				reqGetStudioPlayLists();
			}
		};

		if (isError) {
			toast.error('Something went wrong', {
				position: 'top-center',
				duration: 3000
			});
			setPlaylists([]);
			reqGetStudioPlayLists();
			return;
		}

		handlePlaylistData();
	}, [resGetStudioPlayLists, data, isError, dispatch]);

	const [index, setIndex] = useState(0);

	const fld = playlists?.length > 0 && playlists[index];

	const [modal, setModal] = useState(false);
	const [playlistmodal, setPlaylistmodal] = useState(false);
	const [updatePlayList, setUpdatePlayList] = useState([]);
	const [playListId, setPlayListId] = useState(null);
	const [isReordering, setIsReordering] = useState(false);
	const [shuffledData, setShuffledData] = useState([]);
	const [prevVideos, setPrevVideos] = useState([]);
	const [showUndo, setShowUndo] = useState(false);
	const [isLoading, setLoading] = useState(false)
	const [currentVideos, setCurrentVideos] = useState(sortVideosByPosition(fld?.videos) || [])
	const [reorderedPayload, setReorderedPayload] = useState(null);
	const saveTimeoutRef = useRef(null);

	useEffect(() => {
		setCurrentVideos(sortVideosByPosition(fld?.videos))
	}, [fld?.videos])

	useEffect(() => {
		setShuffledData([]);
	}, [fld?._id]);

	const handleReorderClicked = () => {
		setIsReordering(true);
		setPrevVideos(currentVideos);
	};
	const handleReorder = (next, updates) => {
		setCurrentVideos(next);
		// TODO: Build optimized payload using 'updates' array from parameters of this function  to send to backend instead of sending full updated playlist
		const reorderedPositions = next.map((item, index) => ({
        _id: item?.id,
        newPosition: index
    }));

		setReorderedPayload({
			type: playlists[0]?.type,
			playlistId: fld?._id,
			reorderedPositions,
		});
	}

	const handleSaveOrder = async (payload = reorderedPayload) => {

		if (payload === undefined || payload === null) {
			setIsReordering(false);

			return;
		}
		try {
			setLoading(true)
			const response = await playlistApi.saveNewOrderToBackend(payload);
			await reqGetStudioPlayLists();
			setIsReordering(false);
			Toast.success('Playlist reordered successfully!');
		} catch {
			Toast.error('Error saving order');
		}
		finally {
			setLoading(false)
		}
	};

	const handleUndo = async () => {
		setLoading(true);
		clearTimeout(saveTimeoutRef.current);
		reqGetStudioPlayLists()
		setCurrentVideos(playlists[0].videos);
		setLoading(false)
		window.location.reload();
		setShowUndo(false);
	};


	const onEdit = (e, dt) => {
		e.preventDefault();
		setModalShow(!showModal);
		setIsReordering(false)
		setEditPlaylistID(dt?._id);
	};

	const onDelete = (e, dt) => {
		e.preventDefault();
		setPlayListId(dt?._id);
		setPlaylistmodal(true);
	};

	const onConfirmActionPlaylist = () => {
		if (playListId) {
			reqDeleteStudioPlayList(playListId);
		}
	};
	const onCancelActionPlaylist = () => {
		setPlayListId(null);
		setPlaylistmodal(false);
	};

	useEffect(() => {
		if (resDeleteStudioPlayList.isSuccess) {
			reqGetStudioPlayLists();
			setPlaylistmodal(false);
			toast.success('Playlist deleted Successfully', {
				position: 'top-center',
				duration: 3000
			});
		}
		if (resDeleteStudioPlayList.isError) {
			setPlaylistmodal(false);
			toast.error('Something went wrong', {
				position: 'top-center',
				duration: 3000
			});
		}
	}, [resDeleteStudioPlayList]);


	const handleShuffle = (e, currentPlaylist) => {
		e.preventDefault();
		const currentVideos = currentPlaylist?.videos || [];
		const shuffledArray = [...currentVideos];
		for (let i = shuffledArray.length - 1; i > 0; i--) {
			const j = Math.floor(Math.random() * (i + 1));
			[shuffledArray[i], shuffledArray[j]] = [shuffledArray[j], shuffledArray[i]];
		}

		setPrevVideos(currentVideos);
		setCurrentVideos(shuffledArray);
		setShuffledData(shuffledArray);


		// Build payload like handleReorder
		const reorderedPositions = shuffledArray.map((item, index) => ({
			_id: item._id,
			newPosition: index,
		}));

		const newPayload = {
			type: playlists[0]?.type,
			playlistId: fld?._id,
			reorderedPositions,
		}
		setReorderedPayload(newPayload);

		setShowUndo(true);

		// Set timeout to save order after 5 seconds if user doesn't undo
		Toast.showToast(<UndoModal onSave={() => handleSaveOrder(newPayload)} onUndo={handleUndo} />, { duration: 5000 });
	};

	const handleDeleteVideo = (e, fld, vd) => {
		// console.log("eeeeeeee", fld, vd);
		setCurrentPlaylistId(fld?._id);
		videoIdsToRemove.push(vd?._id);
		setUpdatePlayList(videoIdsToRemove);
		setModal(true);
	};

	const onConfirmAction = () => {
		if (updatePlayList) {
			reqPatchStudioPlayList({
				id: currentPlaylistId,
				payload: { videoIdsToRemove: updatePlayList }
			});
		}
	};

	const onCancelAction = () => {
		setUpdatePlayList(null);
		setModal(false);
	};

	useEffect(() => {
		if (resPatchStudioPlayList.isSuccess) {
			reqGetStudioPlayLists();
			console.log('success', resPatchStudioPlayList);
			setModal(false);
			toast.success('Deleted successfully', {
				position: 'top-center',
				duration: 3000
			});
		}
		if (resPatchStudioPlayList.isError) {
			console.log('error', resPatchStudioPlayList);
			setModal(false);
			toast.error('Something went wrong', {
				position: 'top-center',
				duration: 3000
			});
		}
	}, [resPatchStudioPlayList]);

	useEffect(() => {
		if (shuffledPlaylists) {
			setPlaylists(shuffledPlaylists);
		}
	}, [shuffledPlaylists]);




	useEffect(() => {
		if (!showModal) {
			reqGetStudioPlayLists();
		}
	}, [showModal, nshowModal]);


	return (
		<>
			<div className="row m-0 c-mobile_honm-serch update">
				<MobileViewSearch />
			</div>

			<div>
				<div className="tab-content">
					<div id="menu2" className="tab-pane fade active show">
						<AllPlayList
							title="STUDIO PLAYLISTS"
							data={playlists}
							nshowModal={nshowModal}
							setnModalShow={setnModalShow}
							page="Studio"
							currentIndex={index}
							setCurrentIndex={setIndex}
							subscribtionStatus={subscribtionStatus}
							isEditMode={isReordering}
							onDelete={onDelete}
						/>
						<PlaylistEditModal
							showModal={showModal}
							setModalShow={setModalShow}
							handleClose={handleClose}
							editPlaylistID={editPlaylistID}
							setnModalShow={setnModalShow}
							nshowModal={nshowModal}
						/>
						<DisplayPlaylistVideos
							currentVideos={shuffledData.length > 0 ? shuffledData : currentVideos}
							fld={fld}
							index={index}
							handleShuffle={handleShuffle}
							handleDeleteVideo={handleDeleteVideo}
							onEdit={onEdit}
							onDelete={onDelete}
							onSave={() => handleSaveOrder()}
							onReorderClicked={handleReorderClicked}
							onReorder={handleReorder}
							isReordering={isReordering}
							subscriptionStatus={subscribtionStatus}
						/>
					</div>
				</div>
			</div>
			<DeleteModal modal={modal} onConfirmAction={onConfirmAction} onCancelAction={onCancelAction} />
			<DeleteModalPlayList
				modal={playlistmodal}
				onConfirmAction={onConfirmActionPlaylist}
				onCancelAction={onCancelActionPlaylist}
			/>

		</>
	);
};

export default StudioPlayList;
